export default "__VITE_ASSET__CAanm$FQ__"